// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-warning-labels/inventory-manual-create.less
// module id = 3507
// module chunks = 0